import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FaqPreview() {
  const list = faqs.slice(0, 4);
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="bg-background-100 border-y border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-2">
            <SectionHeading
              eyebrow="FAQ"
              title="常见问题解答"
              desc="关于韩国免费漫画的入口、日更、无遮拦等常见疑问，这里都有答案。"
            />
            <Link
              to="/faq"
              className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              查看更多问题 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="lg:col-span-3 space-y-3">
            {list.map((f, i) => (
              <div key={f.id} className="rounded-lg bg-background-200/60 border border-background-300/50 overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-3.5 text-left"
                >
                  <span className="font-heading text-sm text-foreground-950">{f.q}</span>
                  <span
                    className={`w-7 h-7 shrink-0 rounded-full bg-primary-100/60 text-primary-500 flex items-center justify-center transition-transform ${
                      open === i ? "rotate-45" : ""
                    }`}
                  >
                    <i className="ri-add-line text-sm"></i>
                  </span>
                </button>
                {open === i && (
                  <p className="px-4 md:px-5 pb-4 text-sm text-foreground-700 leading-relaxed">{f.a}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}